import React from "react";
import { Link } from "react-router-dom";
import { Play, Lock, Sparkles, Users } from "lucide-react";

// Visual game tile used in the homepage grid. `featured` doubles the size
// and shows the long blurb; otherwise we render the compact card.
// `onlineCount` (optional) renders a live "Players Online" badge — only
// shown for live games. Coming-soon games show the Coming Soon pill instead.
export default function GameCard({ game, featured = false, onlineCount = null }) {
  const Icon = game.icon;
  const isLive = game.status === "live";
  const cls = `game-card ${featured ? "featured" : ""} ${isLive ? "live" : "coming"}`;
  const style = {
    "--game-accent": game.accent,
    "--game-accent-2": game.accent2,
  };

  const inner = (
    <>
      <div className="game-card-bg" aria-hidden="true" />
      <div className="game-card-body">
        <div className="game-card-icon">
          <Icon size={featured ? 44 : 30} strokeWidth={2.25} />
        </div>
        <div className="game-card-text">
          <div className="game-card-title-row">
            <h3 className="game-card-title">{game.title}</h3>
            {game.status === "coming-soon" && (
              <span className="game-card-pill coming">
                <Sparkles size={11} /> Coming Soon
              </span>
            )}
            {isLive && featured && (
              <span className="game-card-pill live">
                LIVE
              </span>
            )}
            {isLive && onlineCount !== null && onlineCount > 0 && (
              <span
                className="game-card-pill online"
                data-testid={`game-card-online-${game.id}`}
                title={`${onlineCount} player${onlineCount === 1 ? "" : "s"} online right now`}
              >
                <span className="online-dot" aria-hidden="true" />
                <Users size={10} /> {onlineCount}
              </span>
            )}
          </div>
          <p className="game-card-tagline">{game.tagline}</p>
          {featured && <p className="game-card-blurb">{game.blurb}</p>}
        </div>
        <div className="game-card-cta">
          {isLive ? (
            <span className="game-card-btn primary" data-testid={`game-card-play-${game.id}`}>
              <Play size={featured ? 18 : 14} /> Play
            </span>
          ) : (
            <span className="game-card-btn locked" data-testid={`game-card-preview-${game.id}`}>
              <Lock size={featured ? 16 : 12} /> Preview
            </span>
          )}
        </div>
      </div>
    </>
  );

  return (
    <Link
      to={game.route}
      className={cls}
      style={style}
      data-testid={`game-card-${game.id}`}
      data-status={game.status}
    >
      {inner}
    </Link>
  );
}
